import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bqjnry3mfv: FaireBrandEntity = {
  token: "b_bqjnry3mfv",
  type: "brand",
  name: "Haffs Hot Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/eba484f55ca36cd7eaa1d25fe25f663eb60e74613f54d791149ec5351b565842.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0c7a43dae512efbe8c3f1fb36a46185f93a593f9eb60576fb4e060e6539e9084.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eba484f55ca36cd7eaa1d25fe25f663eb60e74613f54d791149ec5351b565842.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0c7a43dae512efbe8c3f1fb36a46185f93a593f9eb60576fb4e060e6539e9084.jpeg",
  location: "44663, OH, USA",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Haffs Hot Sauce is a small batch company that specializes in all natural hot sauces.  We have had the best selling small batch pickle hot sauce since 2020.  Haffs keeps it tasty, healthy, and original.  No extra preservatives.  Just the good stuff.  Make it Haff day! ",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:48.997Z",
    importedBy: "entity-db-cli",
  },
};
